<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI CẤU HÌNH</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT CẤU HÌNH</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT CẤU HÌNH</h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <b-row>
            <b-col lg="12">
              <div class="d-flex mt-2 mb-4">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Giới thiệu: Cấu hình cho phần giới thiệu trang LandingPage. 
                  Bài viết: Cấu hình cho phần ảnh nền trang Bài viết LandingPage"
                  placement="top"
                >
                  <span style="color: #606266; font-size: 15px"
                    >Lựa chọn loại cấu hình:&emsp;</span
                  >
                </el-tooltip>

                <el-switch
                  style="display: block"
                  v-model="switchLoaiCauHinh"
                  active-color="#13ce66"
                  inactive-color="#409eff"
                  active-text="Bài viết"
                  inactive-text="Giới thiệu"
                  @change="showswitch"
                >
                </el-switch>
              </div>

              <el-form-item label="Tên cấu hình:" prop="ten">
                <div class="d-flex">
                  <span v-if="switchLoaiCauHinh == true">anh_nen_&ensp;</span>
                  <span v-else>content_&ensp;</span>
                  <el-input
                    v-model="mData.dataForm.ten"
                    :disabled="mData.viewMode == 'detail'"
                    clearable
                  ></el-input>
                </div>
              </el-form-item>
            </b-col>
            <b-col lg="12">
              <el-form-item label="Giá trị" prop="gia_tri">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.gia_tri"
                  :disabled="
                    mData.viewMode == 'detail' || this.switchLoaiCauHinh == true
                  "
                  @change="fn_trimData()"
                  class="giaTri"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  @change="fn_hideCauHinh"
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.cong_khai"
                  >Công khai</el-checkbox
                >
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item
            v-show="switchLoaiCauHinh == true"
            class="image-baiViet"
            label="Ảnh bìa trang Bài viết"
          >
            <div class="d-flex">
              <div
                class="media-btn"
                :class="{ deactiveBtn: mData.viewMode == 'detail' }"
              >
                <i class="fas fa-image"></i>
                <label for="uploadImageBaiViet">Tải ảnh</label>
                <input
                  type="file"
                  id="uploadImageBaiViet"
                  accept="image/*"
                  @change="fn_uploadImageBaiViet"
                  @click="fn_onInputClick"
                  style="display: none"
                  :disabled="mData.viewMode == 'detail'"
                />
              </div>
              <el-button
                type="danger"
                plain
                icon="el-icon-delete"
                v-show="mData.dataForm.anh_btn_show"
                @click="fn_remove('anh')"
                style="margin-left: 5px"
              ></el-button>
            </div>
            <div class="show-image">
              <div v-if="upLoadImageFinish">
                <Circle4
                  style="width: 40px !important; height: 40px !important"
                  class="show-image-loading"
                ></Circle4>
              </div>

              <img
                :src="mData.dataForm.anh_url"
                alt="ảnh bìa trang bài viết"
                v-show="mData.dataForm.anh_show"
                style="max-height: 320px; width: 100%; object-fit: cover"
              />
            </div>
          </el-form-item>
          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addCauHinh()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormCauHinh";
import { Circle4 } from "vue-loading-spinner";
export default {
  components: {
    Circle4,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      hideCauHinh: false,
      loading: true,
      upLoadImageFinish: false,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        validForm: {
          ten: [ValidService.required],
          gia_tri: [ValidService.required],
        },
      },
      switchLoaiCauHinh: true,
    };
  },
  methods: {
    showswitch(event) {
      console.log("event", event);
      this.switchLoaiCauHinh = event;
    },
    async fn_initForm() {
      try {
        const response = await mushroom.ldp_cau_hinh.findByIdAsync({
          id: this.$router.currentRoute.params.id,
          fields: "ten,gia_tri,cong_khai,thoi_diem_cap_nhat",
        });
        this.mData.dataForm = response.result;
        this.loading = false;
        console.log("Cấu Hình chi tiết:", this.mData.dataForm);
        if (this.mData.dataForm.ten.indexOf("content_") == 0) {
          this.switchLoaiCauHinh = false;

          this.mData.dataForm.ten = this.mData.dataForm.ten.slice(8);
        } else this.switchLoaiCauHinh = true;
        if (this.mData.dataForm.ten.indexOf("anh_nen_") == 0) {
          this.mData.dataForm.ten = this.mData.dataForm.ten.slice(8);
          this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
            .id(this.mData.dataForm.gia_tri)
            .build();
          this.mData.dataForm.anh_show = true;
          this.mData.viewMode === "update"
            ? (this.mData.dataForm.anh_btn_show = true)
            : (this.mData.dataForm.anh_btn_show = false);
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // thêm Cấu Hình mới
    async fn_addCauHinh() {
      let loaiCauHinh = "";
      this.switchLoaiCauHinh
        ? (loaiCauHinh = "anh_nen_")
        : (loaiCauHinh = "content_");
      const ldp_cau_hinh_object = {
        ten: loaiCauHinh + this.mData.dataForm.ten,
        gia_tri: this.mData.dataForm.gia_tri,
        cong_khai: this.hideCauHinh,
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          console.log(ldp_cau_hinh_object);
          try {
            await mushroom.ldp_cau_hinh.createAsync(ldp_cau_hinh_object);
            MethodService.stopLadda();
            window.toastr.success("Thêm mới Cấu Hình thành công");
            this.$router.push({
              name: "DanhSachCauHinh",
            });
          } catch (error) {
            console.log(error.message);
            if (error.code == -1) {
              window.toastr.warning("Tiêu đề đã tồn tại");
            } else if (error.code === 4) {
              window.toastr.error(this.aLang.no_server);
            } else if (error.code === 2) {
              window.toastr.error("Gặp sự cố tải dữ liệu");
            } else {
              window.toastr.error("Đã có lỗi xảy ra");
            }
            MethodService.stopLadda();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_hideCauHinh() {
      console.log("change");
      this.hideCauHinh = !this.hideCauHinh;
    },
    // cập nhật Cấu Hình
    async fn_update() {
      let loaiCauHinh = "";
      this.switchLoaiCauHinh
        ? (loaiCauHinh = "anh_nen_")
        : (loaiCauHinh = "content_");
      const ldp_cau_hinh_object = {
        id: this.$router.currentRoute.params.id,
        ten: loaiCauHinh + this.mData.dataForm.ten,
        gia_tri: this.mData.dataForm.gia_tri,
        cong_khai: this.mData.dataForm.cong_khai,
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            const response = await mushroom.ldp_cau_hinh.partialUpdateAsync(
              ldp_cau_hinh_object
            );
            if (response.result == this.$router.currentRoute.params.id) {
              console.log("1111111", ldp_cau_hinh_object);
              window.toastr.success("Cập nhật Cấu Hình thành công");
              MethodService.stopLadda();
              this.$router.push({
                name: "DanhSachCauHinh",
              });
            } else {
              window.toastr.warning("Dữ liệu không thay đổi");
              MethodService.stopLadda();
            }
          } catch (error) {
            console.log(error);
            if (error.code == -1) {
              window.toastr.warning("Tiêu đề đã tồn tại");
            } else if (error.code === 4) {
              window.toastr.error(this.aLang.no_server);
            } else if (error.code === 2) {
              window.toastr.error("Gặp sự cố tải dữ liệu");
            } else {
              window.toastr.error("Đã có lỗi xảy ra");
            }
            MethodService.stopLadda();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_trimData() {
      this.mData.dataForm.ten = this.mData.dataForm.ten
        ? this.mData.dataForm.ten.trim()
        : "";
      this.mData.dataForm.gia_tri = this.mData.dataForm.gia_tri
        ? this.mData.dataForm.gia_tri.trim()
        : "";
    },
    // quay lại danh sách Cấu Hình
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },

    // thao tác ảnh
    async fn_uploadImageBaiViet() {
      this.upLoadImageFinish = true;
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById("uploadImageBaiViet").files[0], // required
        });

        this.$forceUpdate();
        this.mData.dataForm.gia_tri = res.result;
        this.mData.dataForm.anh_show = true;
        this.mData.dataForm.anh_url = mushroom.$file.linkBuilder.thumb
          .id(res.result)
          .build();

        this.mData.dataForm.anh_btn_show = true;
        console.log("this.mData.dataForm.bai_viet_cover_id: ", res.result);
        setTimeout(() => {
          this.upLoadImageFinish = false;
        }, 6000);
      } catch (error) {
        console.log(error);
      }
    },

    // reset lại thẻ input khi vừa xóa ảnh/video
    fn_onInputClick(event) {
      event.target.value = "";
    },

    // xóa ảnh và video vừa upload
    async fn_remove() {
      this.mData.dataForm.anh_show = false;
      this.mData.dataForm.anh_url = "";
      this.mData.dataForm.gia_tri = null;
      this.mData.dataForm.anh_btn_show = false;
      this.$forceUpdate();
    },
  },

  async created() {
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemCauHinh") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietCauHinh") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatCauHinh") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .slideText textarea {
  height: 150px;
}
label {
  margin-bottom: 0;
}
.uploadImage {
  position: relative;
}

::v-deep .el-upload--text {
  display: none;
}
::v-deep .flower-spinner {
  background-color: transparent;
}
.video {
  border: 1px solid #dcdfe6;
  padding: 10px;
  border-radius: 3px;
  &__btnGroup {
    margin-bottom: 5px;
  }
}

::v-deep .giaTri .el-textarea__inner {
  min-height: 250px !important;
}
.media-btn {
  padding: 0px 10px;
  border: 1px solid #b3d8ff;
  border-radius: 3px;
  width: fit-content;

  color: #3b5dbf;
  background-color: #ecf5ff;
  transition: 0.3s;
  &:hover {
    background-color: #409eff;
    color: #fff;
  }
  label {
    cursor: pointer;
  }
  i {
    margin-right: 5px;
  }
}
.show-image-loading {
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translate(-50%, -50%);
}
.deactiveBtn {
  border: 1px solid #d3d4d6;
  background-color: #f4f4f5;
  color: rgb(109, 109, 109);
  &:hover {
    background-color: #f4f4f5;
    color: rgb(109, 109, 109);
  }
  label,
  i {
    cursor: no-drop;
  }
}
</style>
